import React, { FC } from 'react';
import PropTypes, { InferProps } from 'prop-types'


const propTypes = {
  /**
   * Cor de destaque (nome da variável css)
   */
  cor: PropTypes.string
}

type DestaqueProps = InferProps<typeof propTypes>

export enum CorDestaque {
  Vermelho = 'var(--color-red-300)',
  Azul = '#0070f3',
  Verde = '#00b090'
}

export const Destaque: FC<DestaqueProps> = (props) => {
  return <span style={{color: `${props.cor}`}}>{props.children}</span>
}

Destaque.defaultProps = {
  cor: CorDestaque.Vermelho
}
Destaque.propTypes = propTypes